function btnShowElem(e) {
    const _this = e.target;
    const elemParent = _this.parentNode;
    _this.classList.add('active');
    elemParent.classList.add('active');
    elemParent.querySelector('.dropdown-menu').classList.add('show');
}
function btnCloseElem(e) {
    const elemShow = document.querySelector(
        '.funnelback-search .bx-sort-container .show'
    );
    elemShow.classList.remove('show');
    const elemActive = document.querySelector(
        '.funnelback-search .bx-sort-container .btn-dropdown-toggle.active'
    );
    elemActive.classList.remove('active');
    e.stopImmediatePropagation();
}
function fbDropDown() {
    const buttons = document.querySelectorAll(
        '.funnelback-search .bx-sort-container .btn-dropdown-toggle'
    );
    Object.values(buttons).map((v) => {
        if (v) {
            v.addEventListener('click', function (e) {
                btnShowElem(e);
                e.stopImmediatePropagation();
            });
        }
        return true;
    });
}
function fbDropDownBtnClose() {
    const buttons = document.querySelectorAll(
        '.funnelback-search .bx-sort-container .bg-dropdown'
    );
    Object.values(buttons).map((v) => {
        if (v) {
            v.addEventListener('click', function (e) {
                btnCloseElem(e);
                e.stopImmediatePropagation();
            });
        }
        return true;
    });
}
function btnShowSearch(e) {
    const _this = e.target;
    const elemParent = _this.parentNode;
    const ifActive = _this.classList.contains('active');
    if (ifActive === false) {
        _this.classList.add('active');
        elemParent.classList.add('active');
        elemParent.querySelector('.header-search').classList.add('active');
    } else {
        _this.classList.remove('active');
        elemParent.classList.remove('active');
        elemParent.querySelector('.header-search').classList.remove('active');
    }
}
function btnMobile() {
    const buttons = document.querySelectorAll(
        '.header-search-wrapper .btn-search'
    );
    Object.values(buttons).map((v) => {
        if (v) {
            v.addEventListener('click', function (e) {
                btnShowSearch(e);
                e.stopImmediatePropagation();
            });
        }
        return true;
    });
}
export { btnShowElem, btnCloseElem };
fbDropDown();
fbDropDownBtnClose();
btnMobile();
